var _text, _path, _text2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 660 205"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#C5C6C7",
    fontSize: 182,
    fontFamily: "ArchivoBlack-Regular, Archivo Black",
    transform: "translate(475.13 153.98)"
  }, "el")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C6C7",
    d: "M432.18 58.25v35.08a6.24 6.24 0 01-6.24 6.23h-.3a6.36 6.36 0 01-5.94-6.41v-34.9h-42.36a3.36 3.36 0 00-3.34 3.37 3 3 0 000 .42c2.08 16.88 10.41 84.85 10.45 85.14.53 3.8 2.66 6.8 5.65 6.8h71.7c3 0 5.09-3.18 5.64-6.8.05-.27 8.37-68.25 10.45-85.13a3.37 3.37 0 00-2.89-3.77 3.25 3.25 0 00-.44 0zm17.55 59.46a17.85 17.85 0 01-4 11c-3.23 4-9.13 9.39-19.82 15.56-10.7-6.18-16.58-11.6-19.83-15.56a17.85 17.85 0 01-4-11l-.65-40.11h14.72v16.2a9.71 9.71 0 1019.42.34 1.93 1.93 0 000-.34V77.6h14.75z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#C5C6C7",
    fontSize: 182,
    fontFamily: "ArchivoBlack-Regular, Archivo Black",
    transform: "translate(0 153.98)"
  }, "Sho")));
}

export default SvgTitle;